// extracted by mini-css-extract-plugin
export default {"tooltip":"lV-z","arrow":"mV-z"};